import { Building2Icon, MapPinIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { dates } from "@/lib/dates";
import { EducationType } from "@/types";

export const Education = ({ education }: { education: EducationType }) => {
  const dateDisplay =
    dates.prepareDateDisplayForCertificationOrEducationOrWorkExperience({
      startMonth: education.startMonth ?? undefined,
      startYear: education.startYear ?? undefined,
      endMonth: education.endMonth ?? undefined,
      endYear: education.endYear ?? undefined,
      current: education.current ?? undefined,
    });

  const degree = education.degree?.trim();
  const school = education.school?.trim();

  const dot = <span className="text-slate-500">·</span>;
  const hasLocation = !!education.location;

  return (
    <Row className="items-start gap-4">
      <Row className="h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-50">
        <Building2Icon className="h-5 w-5 text-slate-400" />
      </Row>
      <Column className="min-w-0 flex-1 gap-0.5">
        <Row className="flex-wrap items-baseline gap-x-2">
          {degree ? (
            <Text variant="header">{degree}</Text>
          ) : (
            <Text className="italic text-red-400" variant="header">
              [Missing Degree]
            </Text>
          )}
          {dot}
          {school ? (
            <Text className="font-normal text-slate-500">{school}</Text>
          ) : (
            <Text className="font-normal italic text-red-400">
              [Missing School]
            </Text>
          )}
        </Row>
        {(dateDisplay || hasLocation) && (
          <Row className="flex-wrap items-center gap-x-2 text-sm text-slate-500">
            {dateDisplay && <span>{dateDisplay}</span>}
            {dateDisplay && hasLocation && dot}
            {hasLocation && (
              <Row className="items-center gap-1">
                <MapPinIcon className="h-3.5 w-3.5" />
                <span>{education.location}</span>
              </Row>
            )}
          </Row>
        )}
      </Column>
    </Row>
  );
};
